import { PayloadContent } from '../payload-content.model';

export class WifiProfile extends PayloadContent {
  /**
   * SSID of the Wi-Fi network to be used.
   * In iOS 7.0 and later, this is optional if a DomainName value is provided
   */
  public SSID_STR: string;

  /**
   * Besides SSID, the device uses information such as broadcast type and encryption type to differentiate a network.
   * By default (false), it is assumed that all configured networks are open or broadcast. To specify a hidden network, must be true.
   */
  public HIDDEN_NETWORK = false;

  /**
   * Optional. Default true. If true, the network is auto-joined. If false, the user has to tap the network name to join it.
   * Availability: Available in iOS 5.0 and later and in all versions of macOS.
   */
  public autoJoin = true;

  /**
   * The possible values are WEP, WPA, WPA2, Any, and None. WPA specifies WPA only; WPA2 applies to both encryption types.
   * Make sure that these values exactly match the capabilities of the network access point.
   * If you're unsure about the encryption type, or would prefer that it apply to all encryption types, use the value Any.
   * Availability: Key available in iOS 4.0 and later and in all versions of macOS.
   * The None value is available in iOS 5.0 and later and the WPA2 value is available in iOS 8.0 and later.
   */
  public encryptionType: string;

  /**
   * Optional. Default false. If true, the network is treated as a hotspot.
   * Availability: Available in iOS 7.0 and later and in macOS 10.9 and later.
   */
  public isHotspot = false;

  /**
   * Optional. Domain Name used for Wi-Fi Hotspot 2.0 negotiation. This field can be provided instead of SSID_STR.
   * Availability: Available in iOS 7.0 and later and in macOS 10.9 and later..
   */
  public domainName: string;

  /**
   * Optional. If true, allows connection to roaming service providers. Defaults to false.
   * Availability: Available in iOS 7.0 and later and in macOS 10.9 and later.
   */
  public serviceProviderRoamingEnabled = false;
  public roamingConsortiumOIs: string[];
  public naiRealmNames: string[];
  public mccAndMNCs: string[];
  public displayedOperatorName: string;
  public proxyType: string;
  public captiveBypass: boolean;
  // public qosMarkingPolicy: Map<string, object>; // TODO

  public password: string;
  // public EAPClientConfiguration: any;
  public payloadCertificateUUID: string;

  public proxyServer: string;
  public proxyServerPort?: number;
  public proxyUsername: string;
  public proxyPassword: string;
  public proxyPACURL: string;
  public proxyPACFallbackAllowed: boolean;

  /**
   * Optional. If true, disables MAC address randomization for a Wi-Fi network while associated with that network.
   * This feature also shows a privacy warning in Settings indicating that the network has reduced privacy protections.
   * If false, then the system enables MAC address randomization.
   * This value is only locked when MDM installs the profile. If the profile is manually installed, the system sets the value but the user can change it.
   * Availability: Available in iOS 14 and later, macOS 15 and later, and watchOS 7 and later.
   */
  public disableAssociationMACRandomization?: boolean;

  constructor() {
    super();

    this.payloadType = 'com.apple.wifi.managed';
  }
}
